<template>
  <div class="start">
    <div class="columns is-centered">
      <section class="content-box column is-three-quarters">
        <p>Här hittar du teckningsblanketter</p>
        <hr />
        <table class="table" v-if="forms && forms.length > 0">
          <thead>
            <tr>
              <th>Id</th>
              <th>Namn</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="form in forms">
              <td>{{ form.id }}</td>
              <td>
                <router-link :to="`/form/${form.url || form.id}`">
                  {{ form.name }}
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
        <hr v-if="forms && forms.length > 0" />
      </section>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
const apiUrl = 'https://shares-subscription-forms-api.reguity.com';
export default {
  name: 'start',
  data: () => ({
    forms: null
  }),
  mounted: async function() {
    console.warn('datta');
    try {
      let { data } = await axios.get(`${apiUrl}/forms`);
      this.forms = data;
      this.success = true;
    } catch (err) {
      this.success = false;
    }
  },
  components: {
    //HelloWorld
  }
}
</script>
